import { render, staticRenderFns } from "./PushMessage.vue?vue&type=template&id=64334b9e&"
import script from "./PushMessage.vue?vue&type=script&lang=js&"
export * from "./PushMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports